import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://shthdchrajormjaupqod.supabase.co',
  'sb_publishable_9THDzlRxBFctLlPfw1sBRA_K8Jflqyq'
);
